import React, { Component } from 'react';

import Button from '../form/Button';
import Subnav from '../subnav';
import MembersList from './MembersList';
import OrganizationApi from '../../api/organization';

import withEhsPageBehavior from '../../withEhsPageBehavior';
import { history } from '../../state/store';

class ManageOrganizationTeamPage extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            members: [],
            isLoading: false,
            orgId: '',
        };

        this.getMembers = this.getMembers.bind(this);
    }

    componentWillMount() {
        this.getMembers();
    }

    getMembers() {
        const orgId = this.props.match.params.organizationId;
        this.setState({ isLoading: true }, () => {
            OrganizationApi.getMembers(orgId)
                .then(members => {
                    this.setState({
                        members: members || [],
                        isLoading: false,
                    });
                })
                .catch(err => {
                    this.setState({ members: [], isLoading: false });
                });
        });
    }

    render() {
        let content = (
            <div className="sidebarpage__content">
                <h2>
                    <i className="fa fa-circle-o-notch m2spin" />
                    Loading Organization Team...
                </h2>
            </div>
        );

        if (!this.state.isLoading) {
            content = (
                <div className="sidebarpage__content">
                    <MembersList
                        members={this.state.members}
                        organizationId={this.props.match.params.organizationId}
                    />
                    <div className="form__buttons">
                        <Button
                            onClick={() => {
                                history.push(
                                    `/organization/${this.props.match.params.organizationId}/team/new`
                                );
                            }}
                            defaultText="Add Member"
                            icon="fa-plus"
                            size="small"
                        />
                    </div>
                </div>
            );
        }
        return (
            <div className="page">
                <div className="page__subnav">
                    <Subnav
                        organizationId={this.props.match.params.organizationId}
                    />
                </div>
                <div className="sidebarpage">{content}</div>
            </div>
        );
    }
}

export default withEhsPageBehavior(ManageOrganizationTeamPage);
